import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-section">
              <img src={logo} alt="Rippluence" className="footer-logo" />
              <h3>Rippluence</h3>
            </div>
            <p>Connecting rural talent with global opportunities through virtual assistance.</p>
          </div>
          <nav className="footer-section">
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/blog">Community</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <div className="footer-section">
            <h4>Legal</h4>
            <a href="/#" rel="noopener noreferrer">Privacy Policy</a>
            <a href="/#" rel="noopener noreferrer">Terms of Service</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Rippluence. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;